import { z } from "zod";
import { TaskType } from "@remi/enums/task-type";

// SEND_APPEASEMENT task attempts record which appeasement triggered the
// attempt. Actual send / payment flow is driven by AppeasementService and the
// upstash sync processor (lands with ENFRANK-2934); the attempt row exists
// for audit only.
export const SendAppeasementTaskAttemptSchema = z.object({
  type: z.literal(TaskType.SEND_APPEASEMENT),
  appeasementId: z.string().min(1),
});
